import React, { Component } from 'react';
import { Input } from 'antd';
import Label from './label';
import text from './text';

const { TextArea } = Input;

export default class TagArea extends Component {
  constructor(props) {
    super(props);
    const { cStyle } = props;
    let config = null;
    if (cStyle) {
      try {
        config = JSON.parse(cStyle);
      } catch (e) {
        config = {};
      }
    }
    this.state = Object.assign({
      bIsNull: props.bIsNull,
      visible: !props.bHidden,
      readOnly: props.readOnly,
      placeholder: props.placeholder || '',
      err: props.err || '',
      msg: props.msg || '',
    }, config);
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
  }
  handleInputChange = (e) => {
    const value = e && e.target ? e.target.value : e;
    this.props.model.setValue(value);
    this.setState({ value });
  }
  modelSetValue(value) {
    if (!value) {
      this.props.model.setCheckMsg();
      return;
    }
    const reg = /^[0-9A-Za-z\,]+$/
    if (reg.test(value)) {
      this.props.model.setCheckMsg();
    } else {
      this.props.model.setCheckMsg('输入不合法，请检查');
      return;
    }
    value = value.split(',');
    const { textField } = this.state;
    const newValue = [], hashValue = {};
    value.forEach(item => {
      if (hashValue[item]) return;
      hashValue[item] = true;
      const obj = {};
      obj[textField] = item;
      newValue.push(obj);
    });
    this.props.model.setValue(newValue, true);
  }
  handleInputBlur = (e) => {
    let value = e && e.target ? e.target.value : e;
    if (this.props.model) {
      this.modelSetValue(value);
      this.props.model.execute('blur');
    }
  }
  onPressEnter = (e) => {
    let value = e && e.target ? e.target.value : e;
    if (this.props.model) {
      this.modelSetValue(value);
      this.props.model.execute('enter');
    }
  }
  setValue(value) {
    this.setState({ value: cb.utils.isArray(value) && value.join(',') });
  }
  validate(val) {
    this.setState({
      err: 'has-' + val.type,
      msg: val.message
    });
  }
  baseControl() {
    const { readOnly, value, placeholder, disabled, before, after, bottom } = this.state;
    if (readOnly)
      return text(value);
    const props = {
      placeholder: placeholder,
      disabled: disabled,
      // onPressEnter: this.onPressEnter,
      value,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
    };
    const com = <TextArea {...props} />
    if (!after && !bottom && !before)
      return com;
    return (
      <div className="input-bottom">
        <div>{before && <span className="input-before">{before}</span>}
          {com}{after && <span className="input-after">{after}</span>}</div>
        {bottom && <div className="input-bottom-text">{bottom}</div>}
      </div>
    );
  }
  relatedControl() {
    const control = this.baseControl();
    const { relatedControl } = this.props;
    if (!relatedControl)
      return control;
    return (
      <div className='has-related'>
        <div className='viewCell'>{control}</div>
        {relatedControl}
      </div>
    );
  }
  getControl() {
    const { cShowCaption } = this.props;
    const title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
    let control = (cShowCaption ? <Label control={this.relatedControl()} title={title} /> : this.relatedControl());
    return control;
  }
  render() {
    const control = this.getControl();
    let style = this.state.visible ? {} : { display: "none" };
    let errClass = `basic-tagarea has-feedback ${this.state.classname || ''} ` + this.state.err;
    return (
      <div style={style} className={errClass} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        {control}
        <div className="ant-form-explain">{this.state.msg}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/tagarea.jsx